export interface IModelRaw {
  id: string;
  created_at?: number;
  updated_at?: number;
}

export enum EComponent {
  Connect = 'connect',
  Discover = 'discover',
}
